import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"

const authorsNoticeUrl = '/web/submit/queryAuthorsNotice';//投稿须知

const findProvinceListUrl = '/web/common/findProvinceList';//省
const findAreaListUrl = '/web/common/findAreaList';//市
const findEduListUrl = '/web/common/findEduList';//学历
const url23 = '/web/periodical';//期刊
const url24 = '/web/sso';//期刊
let url5 = "/web/subject";//学科管理
let url6 = "/web/order";//二維碼
let url2="/web/myOrder"//订单管理
const getRecommendUrl = '/web/submit/getRecommend';//查询推荐审稿人列表
const submitArticleUrl = '/web/submit/submitArticle';//用户投稿
const saveArticleUrl = '/web/submit/saveArticle';//保存草稿
const checkAuthorUrl = '/web/submit/checkAuthor';//验证作者手机姓名是否一致

const draftsArticleByIdUrl = '/web/articleManage/queryDraftsArticleById';//草稿箱稿件回显
const articleByIdUrl = '/web/articleManage/queryArticleById';//我的稿件回显

const findCopyRightUrl = '/web/periodical/findCopyRight'//版权协议
const url22 = '/web/submit';//在线投稿时的
const author = '/getPeriodInfoForOld'
const apis = {
  authors(data) { //GET /web/periodical/findHistory 期刊历史推荐
		return request({
		  url:url23 + author,
		  method: 'get',
		  params: data
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },
	queryUserRetired(articleId) { //GET /web/periodical/findHistory 期刊历史推荐
		return request({
		  url:"/web/articleManage/queryUserRetired",
		  method: 'get',
		  params: {
				articleId:articleId
			}
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },
	findHistory(data) { //GET /web/periodical/findHistory 期刊历史推荐
		return request({
		  url:url23 + "/findHistory",
		  method: 'get',
		  params: data
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },
	  checkUserInfo(data) { //GET /web/periodical/findHistory 期刊历史推荐
		return request({
		  url:url22+"/checkUserInfo",
		  method: 'post',
		 data: data
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },
	  findWebPeriodicalInfo(data) { //GET期刊详情
		return request({
		  url:url23 + "/findWebPeriodicalInfo",
		  method: 'get',
		  params: data
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },
	  findWebPeriodicalList(data) { //期刊列表
		return request({
		  url:url23 + "/findWebPeriodicalList",
		  method: 'get',
		  params: data
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },
	   //一级学科列表
  findOneList() {
    return request({
      url: url5 + "/findOneList",
      method: 'get',
      params: {
      }
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //二级学科列表
  findTwoList(data) {
    return request({
      url: url5 + "/findTwoList",
      method: 'get',
      params:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  //查询我的订单列表
  findMyOrderList(data) {
    return request({
      url: url2 + "/findMyOrderList",
      method: 'post',
      data:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
	getJobList() {
		return request({
			url: "/zw/title/list",
			method: 'post',
			data:{}
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

  // 查询我的订单详情（付款）
  findMyOrderPayById(data) {
    return request({
      url: url2 + "/findMyOrderPayById",
      method: 'post',
      data:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  // 查询我的订单详情（退款）
  findMyOrderRefundById(data) {
    return request({
      url: url2 + "/findMyOrderRefundById",
      method: 'post',
      data:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
   //生成付款码
   getQrCode(data) {
    return request({
      url: url6+ "/getQrCode",
      method: 'get',
      params:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
   //根据订单id查询订单支付状态
   getPayStatus(data) {
    return request({
      url: url6+ "/billQuery",
      method: 'get',
      params:data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //投稿须知
  authorsNotice(data) {
    return request({
      url: authorsNoticeUrl,
      method: 'get',
      params: data
    }).then((resault) => {
      return Promise.resolve(resault)
    })
  },
  findProvinceList(data) {
    return request({
      url: "/web/common/findProvinceList",
      method: 'get',
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  //获取用户系信息
  getUser(data) {
    return request({
	  url:url24 + "/getUser",
      method: 'get',
      params: data
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  //省
	findProvinceList(data) {
		return request({
			url: findProvinceListUrl,
			method: 'get',
			params:data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//市
	findAreaList(data) {
		return request({
			url: findAreaListUrl,
			method: 'get',
			params:data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

  //学历
	findEduList(data) {
		return request({
			url: findEduListUrl,
			method: 'get',
			params:data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//查询推荐审稿人列表
	getRecommend(data) {
		return request({
			url: getRecommendUrl,
			method: 'get',
			params:data
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//用户投稿
	submitArticle(data) {
		return request({
			url: submitArticleUrl,
			method: 'post',
			data:data,
			jsonString:true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	//保存草稿
	saveArticle(data) {
		return request({
			url: saveArticleUrl,
			method: 'post',
			data:data,
			jsonString:true,
		}).then((resault) => {
			return Promise.resolve(resault.data)
		})
	},

	// 验证作者手机姓名是否一致
  	checkAuthor(data) {
	    return request({
	      url: checkAuthorUrl,
	      method: 'post',
	      data:data
	    }).then((resault) => {
	      return Promise.resolve(resault.data)
	    })
  	},

  	// 草稿箱稿件回显
  	draftsArticleById(data) {
	    return request({
	      url: draftsArticleByIdUrl,
	      method: 'get',
	      params:data,
	    }).then((resault) => {
	      return Promise.resolve(resault.data)
	    })
  	},

  	// 我的稿件回显
  	articleById(data) {
	    return request({
	      url: articleByIdUrl,
	      method: 'get',
	      params:data,
	    }).then((resault) => {
	      return Promise.resolve(resault.data)
	    })
  	},

  	//版权协议
  	findCopyRight(data) {
		return request({
		  url:findCopyRightUrl,
		  method: 'get',
		  params: data
		}).then((resault) => {
		  return Promise.resolve(resault.data)
		})
	  },

}


export default apis



// WEBPACK FOOTER //
// ./src/core/api/author.serve.js